module.exports = __webpack_public_path__ + "static/media/business-intelligence.be650918.png";